<template>
  <div class="fillcontain">
    <search-item
      @showDialog="showAddDialog"
      @searchList="getClassHourSpendList1"
      :username="addDialog.username"
      @changePageAndLimit="handleChangePageAndLimit"
    ></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column
          v-if="idFlag"
          prop="id"
          label="id"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="自定义条目"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="coursePackageId"
          label="课包类型"
          align="left"
          :filters="this.coursePackageData"
          :filter-method="filterCoursePackage"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCoursePackage(scope.row)"
              disable-transitions
              >{{ scope.row.coursePackageId }}</el-tag
            >
          </template>
        </el-table-column>
          <el-table-column
          prop="activeName"
          label="活动名称"
          align="left"
        >
        </el-table-column>
        <el-table-column
          prop="courseHours"
          label="课时增加/减少"
          align="left"
        ></el-table-column>
        <el-table-column prop="operateDate" label="日期" align="left" sortable>
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.opreateDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="idFlag"
          prop="buyDate"
          label="购买时间"
          align="left"
          sortable
        >
          <template slot-scope="scope">
            <el-icon name="time"></el-icon>
            <span style="margin-left: 10px">{{ scope.row.buyDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="notes"
          label="备注"
          align="left"
        ></el-table-column>
        <el-table-column
                prop="remark"
                label="取消原因"
                align="left"
        ></el-table-column>
        <el-table-column
                prop="courseId"
                label="课程编号"
                align="left"
        ></el-table-column>
        <el-table-column
                prop="coursePackageAndMemberId"
                label="会员课包编号"
                align="left"
        ></el-table-column>
        <!-- <el-table-column
          prop="notes"
          label="备注"
          align="left"
        ></el-table-column> -->
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDelete(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <AddClasshourSpendDialog
        v-if="addDialog.show"
        :isShow="addDialog.show"
        :dialogRow="addDialog.dialogRow"
        :username="addDialog.username"
        :name="addDialog.name"
        :coursePackageList="addDialog.coursePackageList"
        @getClassHourList="getClassHourSpendList1"
        @closeDialog="hideAddDialog"
      ></AddClasshourSpendDialog>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddClasshourSpendDialog from "./components/addClasshourSpendDialog";
import { formatDateTime } from "../../utils/date.js";
import Pagination from "@/components/pagination";
import { getFormatCoursePackages } from "@/api/coursepackage";
import {
  getClassHourSpends,
  deleteClassHourSpend,
  getClassHourSpendsByDate,
  deleteClasshourRecordById
} from "@/api/classhourspend";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      coursePackageData: [],
      format_course_package_list: {},
      tableHeight: 0,
      loading: false,
      idFlag: false,
      sortnum: 0,
      addDialog: {
        show: false,
        dialogRow: {},
        username: "oEOcg5bNsAsEb-7ue4QuoY-vGQwY",
        coursePackageList: {},
      },
      classhourSpendData: {
        page: 1,
        limit: 20,
      },
      studentData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
    };
  },
  components: {
    SearchItem,
    AddClasshourSpendDialog,
    Pagination,
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
  },
  mounted() {
    this.addDialog.username = this.user.username;
    this.addDialog.name = this.user.name;
    this.getFormatCoursePackagesList();
    this.getClassHourSpendList1();
  },
  computed: {
    ...mapGetters(["user", "classHourSpendSearch"]),
  },
  methods: {
    handleChangePageAndLimit() {
      this.classhourSpendData.page = 1;
      this.classhourSpendData.limit = 20;
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    getFormatCoursePackagesList() {
      console.log("getFormatCoursePackagesList");
      getFormatCoursePackages({ userName: this.user.username }).then((res) => {
        console.log(res);
        this.coursePackageData = res.data.data.coursePackageData;
        this.format_course_package_list =
          res.data.data.format_course_package_list;
        // console.log(this.coursePackageData);
        var coursePackageData = {
          coursePackageList: this.coursePackageData,
        };
        // console.log(coursePackageData);
        this.addDialog.coursePackageList = coursePackageData;
      });
    },
    getClassHourSpendList1() {
      console.log("getClassHourSpendList1");
      const para = Object.assign(
        this.classhourSpendData,
        this.classHourSpendSearch,
        { username: this.user.username }
      );
      console.log(para);
      getClassHourSpendsByDate(para).then((res) => {
        console.log(res);
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.list;
      });
    },
    //获取课时账单列表数据
    getClasshourSpendList() {
      const para = this.classhourSpendData;
      var username = this.user.username;
      getClassHourSpends(username, para).then((res) => {
        this.tableData = [];
        console.log(res);
        this.loading = false;
        if (res.data.code == 200) {
          this.pageTotal = res.data.data.total;
          this.tableData = res.data.data.list;

          // res.data.data.list.forEach((classhour) => {
          //   var classHoursIndex =
          //     classhour.courseHours.indexOf("+") == -1
          //       ? classhour.courseHours.indexOf("-")
          //       : classhour.courseHours.indexOf("+");
          //   console.log(classHoursIndex);
          //   var classHours = classhour.courseHours.slice(
          //     classHoursIndex,
          //     classhour.courseHours.length
          //   );
          //   var classHourType = classhour.courseHours.slice(0, classHoursIndex);
          //   console.log(this.coursePackageData);
          //   this.coursePackageData.forEach((item) => {
          //     if (classHourType === item.text) {
          //       classHourType = item.value;
          //     }
          //   });
          //   this.tableData.push({
          //     id: classhour.id,
          //     type: classhour.type,
          //     // classhourType: classHourType,
          //     classhours: classHours,
          //     opreateDate: classhour.opreateDate,
          //     notes: classhour.notes,
          //     coursePackageId: classhour.coursePackageId,
          //   });
          // });
        }
      });
    },
    // 显示资金弹框
    showAddDialog(val) {
      this.$store.commit("SET_CLASSHOUR_DIALOG_TITLE", val);
      this.addDialog.show = true;
    },
    hideAddDialog() {
      this.addDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.classhourSpendData.page = val;
      this.getClassHourSpendList1();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.classhourSpendData.limit = val;
      this.getClassHourSpendList1();
    },
    /**
     * 格式化状态
     */
    formatterCoursePackage(item) {
      const type = parseInt(item.coursePackageId);
      return this.format_course_package_list[type];
    },
    filterCoursePackage(value, item) {
      const type = parseInt(item.coursePackageId);
      return (
        this.format_course_package_list[value] ==
        this.format_course_package_list[type]
      );
    },
    // 编辑操作方法
    onEditStudent(row) {
      //   this.$router.push({ path: "/memberManage/fundList" });
      this.addEventDialog.dialogRow = { ...row };
      this.showAddEventDialog();
    },
    // 删除数据
    onDelete(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.id };
          var type = row.type; // 课时账单条目
          var coursehours = row.courseHours; // 课时数
          var note = row.notes; // 备注
          console.log(para);
          console.log(row,'hang');
          deleteClasshourRecordById(para).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              const para = {
                userName: getToken("USERNAME"),
                content:
                  "删除会员(" +
                  this.user.name +
                  ")课时账单操作，" +
                  "课时账单条目为:" +
                  type +
                  ",课时增减为:" +
                  coursehours +
                  ",课时备注为:" +
                  note,
              };
              addOperationRecord(para).then((res) => {
                console.log(res);
              });
              this.getClassHourSpendList1();
            } else {
              this.$message({
                message: "删除失败",
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>


<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>